// frontend/src/components/CRMSettings.jsx

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../api/axiosConfig';

export default function CRMSettings() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: "",
    apiKey: "",
    crmUrl: "",
    emailAddress: ""
  });

  useEffect(() => {
    const fetchCRM = async () => {
      try {
        const token = localStorage.getItem('token');
        console.log('📦 Token sent to server:', token);

        const res = await api.get("/agent/crm-config", {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log('✅ CRM Settings loaded:', res.data);

        if (res.data?.crmConfig) {
          setForm({
            name: res.data.crmConfig.name || "",
            apiKey: res.data.crmConfig.apiKey || "",
            crmUrl: res.data.crmConfig.crmUrl || "",
            emailAddress: res.data.crmConfig.emailAddress || ""
          });
        }
      } catch (err) {
        console.error('❌ Error fetching CRM config:', err);
        toast.error('Unable to load CRM settings.');
      } finally {
        setLoading(false);
      }
    };

    fetchCRM();
  }, []);

  const onChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!form.name.trim() || !form.crmUrl.trim() || !form.emailAddress.trim()) {
      toast.error('Name, CRM URL, and Email are required.');
      return;
    }

    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      await api.post('/agent/crm-config', {
        name: form.name.trim(),
        apiKey: form.apiKey.trim(),
        crmUrl: form.crmUrl.trim(),
        emailAddress: form.emailAddress.trim()
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      toast.success('✅ CRM settings saved!');
    } catch (err) {
      console.error('❌ Error saving CRM settings:', err);
      toast.error('Failed to save configuration.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '100px' }}>Loading CRM settings…</div>;
  }

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>CRM Configuration</h2>
      <form onSubmit={onSubmit}>
        <div style={{ marginBottom: '16px' }}>
          <input
            type="text"
            name="name"
            placeholder="Name *"
            value={form.name}
            onChange={onChange}
            style={inputStyle}
            required
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <input
            type="text"
            name="apiKey"
            placeholder="API Key (Optional)"
            value={form.apiKey}
            onChange={onChange}
            style={inputStyle}
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <input
            type="url"
            name="crmUrl"
            placeholder="CRM URL *"
            value={form.crmUrl}
            onChange={onChange}
            style={inputStyle}
            required
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <input
            type="email"
            name="emailAddress"
            placeholder="Email Address *"
            value={form.emailAddress}
            onChange={onChange}
            style={inputStyle}
            required
          />
        </div>

        <button
          type="submit"
          disabled={saving}
          style={buttonStyle}
        >
          {saving ? 'Saving…' : 'Save Configuration'}
        </button>
      </form>
    </div>
  );
}

const containerStyle = {
  maxWidth: 600,
  margin: '40px auto',
  padding: 20,
  border: '1px solid #ddd',
  borderRadius: 8
};
const inputStyle = {
  width: '100%',
  padding: '10px',
  fontSize: '16px',
  borderRadius: '6px',
  border: '1px solid #ccc',
  outline: 'none'
};
const buttonStyle = {
  width: '100%',
  padding: '12px 0',
  backgroundColor: '#2c3e50',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  cursor: 'pointer',
  fontSize: 16
};